import {
    useTransactionSigner as useRealTransactionSigner,
    type UseTransactionSignerReturn
} from "@solana/connector/react";

import { useSolomonE2ESigner } from "../../e2e";

/**
 * E2E seam for ConnectorKit's `useTransactionSigner`.
 *
 * This is the one piece of real, production-facing code that knows about the
 * `__SOLOMON_E2E__` harness — hence it lives in `hooks/e2e/` rather than the
 * inert-in-prod `wallet/e2e/` folder. Both hooks are called unconditionally
 * every render (React hook rules); the smoke signer wins when present (only
 * reachable under the gated override), otherwise the real signer passes
 * straight through. The return shape is identical to the real hook
 * (`{ signer, ready, address, capabilities }`), so every consumer is
 * unaffected in production — under the override we keep the real hook's
 * `capabilities` and only override `signer`/`ready`/`address`.
 */
export function useTransactionSigner(): UseTransactionSignerReturn {
    const e2eSigner = useSolomonE2ESigner();
    const real = useRealTransactionSigner();

    if (e2eSigner) {
        return {
            ...real,
            signer: e2eSigner as unknown as UseTransactionSignerReturn["signer"],
            ready: true,
            address: e2eSigner.address
        };
    }

    return real;
}
